import React from "react"
import { Route } from "react-router-dom"
import AuthGuard from "../guards/authGuards"
import Overview from "../pages/Dashboard/overview"
import About from "../pages/About/About"
import Eibor from "../pages/EIBOR/Eibor"
import Products from "../pages/Product/Products"
import Properties from "../pages/Properties/Properties"
import ProfilePage from "../pages/Profile/ProfileView"
import Leads from "../pages/Leads/OverallLeads"
import ChatbotLeads from "../pages/Leads/ChatbotLeads"
import ContactLeads from "../pages/Leads/ContactLeads"
import MortgageLeads from "../pages/Leads/MortgageLeads"
import UserManagement from "../pages/Accounts/UserList"
import TeamMembers from "../pages/Accounts/TeamMembers"
import HeroManagement from "../pages/Ads/HeroManagement"
import SEOManagement from "../pages/Ads/SEOManagement"

const AuthRoutes = [
    <Route key="Dashboard" path="/dashboard" element={<AuthGuard name="dashboard" component={<Overview />} />} />,
    <Route key="About" path="/about" element={<AuthGuard name="about" component={<About />} />} />,
    <Route key="Leads" path="/leads" element={<AuthGuard name="leads" component={<Leads />} />} />,
    <Route key="ChatbotLeads" path="/leads/chatbot" element={<AuthGuard name="chatbotleads" component={<ChatbotLeads />} />} />,
    <Route key="ContactLeads" path="/leads/contact" element={<AuthGuard name="contactleads" component={<ContactLeads />} />} />,
    <Route key="MortgageLeads" path="/leads/mortgage" element={<AuthGuard name="mortgageleads" component={<MortgageLeads />} />} />,
    <Route key="Properties" path="/properties" element={<AuthGuard name="properties" component={<Properties />} />} />,
    <Route key="HeroManagement" path="/ads/hero" element={<AuthGuard name="heroads" component={<HeroManagement />} />} />,
    <Route key="SEOManagement" path="/ads/seo" element={<AuthGuard name="seoads" component={<SEOManagement />} />} />,
    <Route key="UserManagement" path="/user-management" element={<AuthGuard name="UserManagement" component={<UserManagement />} />} />,
    <Route key="TeamMembers" path="/team-members" element={<AuthGuard name="TeamMembers" component={<TeamMembers />} />} />,

    <Route key="EIBOR" path="/eibor" element={<AuthGuard name="eibor" component={<Eibor />} />} />,
    <Route key="Products" path="/products" element={<AuthGuard name="products" component={<Products />} />} />,
    <Route key="Profile" path="/profile" element={<AuthGuard name="profilePage" component={<ProfilePage />} />} />,
]

export default AuthRoutes